import { cn } from '@/lib/cn';

export type Status =
  | 'SUBMITTED'
  | 'UNDER_REVIEW'
  | 'IN_PROGRESS'
  | 'APPROVED'
  | 'COMPLETED'
  | 'REJECTED'
  | 'CANCELLED';

const styles: Record<Status, { bg: string; text: string; label: string }> = {
  SUBMITTED:    { bg: 'bg-status-info-bg',     text: 'text-status-info',      label: 'Submitted' },
  UNDER_REVIEW: { bg: 'bg-status-warning-bg',  text: 'text-status-warning-text', label: 'Under review' },
  IN_PROGRESS:  { bg: 'bg-status-info-bg',     text: 'text-status-info',      label: 'In progress' },
  APPROVED:     { bg: 'bg-status-success-bg', text: 'text-status-success',   label: 'Approved' },
  COMPLETED:    { bg: 'bg-status-info-bg',     text: 'text-navy-deep',        label: 'Completed' },
  REJECTED:     { bg: 'bg-status-error-bg',    text: 'text-status-error',     label: 'Rejected' },
  CANCELLED:    { bg: 'bg-line-soft',          text: 'text-ink-muted',        label: 'Cancelled' },
};

export function StatusPill({ status, className }: { status: Status; className?: string }) {
  const s = styles[status] ?? styles.SUBMITTED;
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-pill px-2.5 py-0.5',
        'text-overline uppercase whitespace-nowrap',
        s.bg,
        s.text,
        className,
      )}
    >
      {s.label}
    </span>
  );
}
